var app = angular.module("leonardo");

var ItemDeleteDialog = function($scope, ConfigThemeService, $http, FormErrorsService) {
  $scope.item = $scope.ngDialogData.item;

  $scope.getURL = function (id) {
    var url = ConfigThemeService.generateURL('/api/2.0/templates-workflow');
    if (id) url += '/' + id + '/';
    return url;
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $http.delete($scope.getURL($scope.item.id)).then(function() {
      $scope.confirm();
    });
  };
};

app.controller('ItemDeleteDialog', ['$scope', 'ConfigThemeService', '$http', 'FormErrorsService', ItemDeleteDialog]);
